(function () {
  function initProductSections(scope) {
    var sections = (scope || document).querySelectorAll('[data-pc-products-section]');

    sections.forEach(function (section) {
      if (section.dataset.pcInitialized === 'true') return;
      section.dataset.pcInitialized = 'true';

      var sectionId = section.dataset.sectionId;

      function form() {
        return section.querySelector('[data-pc-filter-form]');
      }

      function sort() {
        return section.querySelector('[data-pc-sort]');
      }

      function buildParams(includeSection) {
        var params = new URLSearchParams();
        var currentForm = form();
        if (!currentForm) return params;

        new FormData(currentForm).forEach(function (value, key) {
          if (value !== '') params.append(key, value);
        });

        if (includeSection) params.set('section_id', sectionId);
        return params;
      }

      function setupPriceRange() {
        var priceRange = section.querySelector('[data-pc-price-range]');
        if (!priceRange || priceRange.dataset.pcPriceInitialized === 'true') return;
        priceRange.dataset.pcPriceInitialized = 'true';

        var priceFilter = priceRange.closest('[data-pc-price-filter]');
        var priceCurrent = priceFilter ? priceFilter.querySelector('[data-pc-price-current]') : null;

        function formatMoney(value) {
          return '$' + Number(value || 0).toLocaleString();
        }

        function updatePriceDisplay() {
          var value = Number(priceRange.value || 0);
          if (priceCurrent) priceCurrent.textContent = formatMoney(value);
        }

        updatePriceDisplay();

        priceRange.addEventListener('input', function () {
          var maxInput = section.querySelector('[data-pc-price-max]');
          if (maxInput) maxInput.value = priceRange.value;
          updatePriceDisplay();
        });

        priceRange.addEventListener('change', refresh);
      }

      function refresh() {
        var sectionParams = buildParams(true);
        var historyParams = buildParams(false);

        section.classList.add('is-loading');

        fetch(window.location.pathname + '?' + sectionParams.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-pc-products-content]');
            var current = section.querySelector('[data-pc-products-content]');

            if (next && current) {
              current.replaceWith(next);
              var historyQuery = historyParams.toString();
              window.history.replaceState({}, '', window.location.pathname + (historyQuery ? '?' + historyQuery : ''));
              section.classList.remove('is-filter-open');
              setupPriceRange();
            }
          })
          .finally(function () {
            section.classList.remove('is-loading');
          });
      }

      section.addEventListener('change', function (event) {
        if (!event.target.closest('[data-pc-filter-form]')) return;
        if (event.target.matches('[data-pc-price-range]')) return;
        refresh();
      });

      section.addEventListener('click', function (event) {
        var filterToggle = event.target.closest('[data-pc-filter-toggle]');
        var sortToggle = event.target.closest('[data-pc-sort-toggle]');
        var sortButton = event.target.closest('[data-sort-value]');
        var clearButton = event.target.closest('[data-pc-clear-filters]');

        if (filterToggle) {
          section.classList.toggle('is-filter-open');
          return;
        }

        if (sortToggle) {
          var currentSort = sort();
          if (currentSort) currentSort.classList.toggle('is-open');
          return;
        }

        if (sortButton) {
          var sortInput = section.querySelector('input[name="sort_by"]');
          var currentSortForButton = sort();

          if (sortInput) sortInput.value = sortButton.dataset.sortValue;
          if (currentSortForButton) currentSortForButton.classList.remove('is-open');
          refresh();
          return;
        }

        if (clearButton) {
          var currentForm = form();
          if (!currentForm) return;

          currentForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
            input.checked = false;
          });

          currentForm.querySelectorAll('[data-pc-price-max], input[type="hidden"]:not([name="sort_by"])').forEach(function (input) {
            input.value = '';
          });

          refresh();
        }
      });

      document.addEventListener('click', function (event) {
        var currentSort = sort();
        if (currentSort && !currentSort.contains(event.target) && !event.target.closest('[data-pc-sort-toggle]')) {
          currentSort.classList.remove('is-open');
        }
      });

      setupPriceRange();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductSections(event.target);
  });
})();
